var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlipXAxis(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    enableBackground: "new 0 0 48 48",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8ACCA1",
    d: "M25.567,24h-2.135c-1.179,0-2.135-0.82-2.135-2c0-1.179,0.956-2,2.135-2h2.135c1.179,0,2.136,0.821,2.136,2 C27.703,23.18,26.746,24,25.567,24z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#8ACCA1",
    d: "M16.315,24H14.18c-1.179,0-2.135-0.82-2.135-2c0-1.179,0.956-2,2.135-2h2.135c1.179,0,2.135,0.821,2.135,2 C18.45,23.18,17.494,24,16.315,24z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#8ACCA1",
    d: "M7.063,24H4.928c-1.179,0-2.135-0.82-2.135-2c0-1.179,0.956-2,2.135-2h2.135c1.179,0,2.135,0.821,2.135,2 C9.198,23.18,8.242,24,7.063,24z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 24.2876,
    y1: 5.563,
    x2: 24.2876,
    y2: 41.0005
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#407A60"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#005443"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M24.288,5.563c-5.857,0-10.273,7.914-10.273,18.131c0,5.085,1.156,9.306,3.161,13.306h-0.861 c-1.179,0-2.135,0.82-2.135,2s0.956,2,2.135,2H23V29.466c0-1.18-0.821-2.136-2-2.136s-2,0.956-2,2.136v0.875 c0-2.054-0.796-4.403-0.796-6.855c0-7.813,3.209-13.652,6.043-13.652c2.834,0,6.024,5.838,6.024,13.652 c0,4.319-0.944,8.337-2.61,11.021c-0.621,1.002-0.308,2.318,0.694,2.94c1.001,0.621,2.319,0.313,2.942-0.688 c2.072-3.342,3.264-8.179,3.264-13.272C34.562,13.268,30.146,5.563,24.288,5.563z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#8ACCA1",
    d: "M44.072,24h-2.135c-1.179,0-2.136-0.82-2.136-2c0-1.179,0.957-2,2.136-2h2.135c1.179,0,2.136,0.821,2.136,2 C46.208,23.18,45.251,24,44.072,24z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#8ACCA1",
    d: "M34.82,24h-2.136c-1.179,0-2.135-0.82-2.135-2c0-1.179,0.956-2,2.135-2h2.136c1.179,0,2.135,0.821,2.135,2 C36.955,23.18,35.999,24,34.82,24z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlipXAxis);
export default __webpack_public_path__ + "static/media/flip_x_axis.7e91c645ce14e962753e6b5c6bc512aa.svg";
export { ForwardRef as ReactComponent };